<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
              <a-input style="width: 200px" v-model="queryParam.orderNo" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'mobileNo')">
              <a-input style="width: 200px" v-model="queryParam.custMobileNo" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange">
    </a-table>

    <div style="margin-top: 15px; text-align: right;">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange" />
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import vPagination from '../modules/pagination'
import { queryAbnormalOrders } from '@/webpublicapi/order'

const I18N_KEY = {
  ORDER: 'order.'
}

export default {
  name: 'CollectionUserSchedule',
  components: {
    vPagination
  },
  data() {
    return {
      total: 0,
      I18N_KEY,
      queryParam: {
        custMobileNo: null,
        orderNo: null
      },
      dataSource: [],
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'productName'
        },
        {
          title: '订单编号',
          align: 'center',
          dataIndex: 'orderNo'
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'custMobileNo'
        },
        {
          title: '本金',
          align: 'center',
          dataIndex: 'capital'
        },
        {
          title: '应还金额',
          align: 'center',
          dataIndex: 'amoutDue'
        },
        {
          title: '真实还款金额',
          align: 'center',
          dataIndex: 'realRepayAmount'
        },
        {
          title: '订单开始时间',
          align: 'center',
          dataIndex: 'beginDate'
        },
        {
          title: '订单结束时间',
          align: 'center',
          dataIndex: 'endDate'
        }
        // {
        //   title: '借款次数',
        //   align: 'center',
        //   dataIndex: 'loanCount'
        // },
        // {
        //   title: '订单审批状态',
        //   align: 'center',
        //   dataIndex: 'approvalStatusName'
        // },
        // {
        //   title: '订单放款状态',
        //   align: 'center',
        //   dataIndex: 'loanStatusName'
        // },
        // {
        //   title: '订单结清状态',
        //   align: 'center',
        //   dataIndex: 'settleStatusName'
        // },
        // {
        //   title: '利息',
        //   align: 'center',
        //   dataIndex: 'interest'
        // },
        // {
        //   title: '逾期天数',
        //   align: 'center',
        //   dataIndex: 'overdueDays'
        // },
        // {
        //   title: '滞纳金',
        //   align: 'center',
        //   dataIndex: 'lateFee'
        // }
        // {
        //   title: '减免金额',
        //   align: 'center',
        //   dataIndex: 'deductionFee'
        // }

        // ,{
        //   title: this.$t('action'),
        //   dataIndex: 'action',
        //   align: 'center',
        //   fixed: 'right',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.search()
    },
    search() {
      this.loading = true
      const params = this.getQueryParams()
      queryAbnormalOrders(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      const params = this.getQueryParams()
      queryAbnormalOrders(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const param = {
        ...this.queryParam,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      return filterObj(param)
    },
    searchReset() {
      this.queryParam.orderNo = undefined
      this.queryParam.custMobileNo = undefined
      this.form.pageNum = 1
      this.loadData(1)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>